module.exports = __webpack_public_path__ + "img/w3_button_reload_grey_light.c485b6cb.png";